// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"aaeedfcc","125":"1d02472e","447":"6ac28023","453":"ea13425e","640":"e612f7e5","967":"363e5df0"}[chunkId] + ".chunk.js";
};